import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export interface IHistogramLogConfigModel extends IRestModel {
    histogramLogPeriod: number;
}

export class HistogramLogConfigModel extends BaseModel implements IHistogramLogConfigModel, IRestModel {
    public readonly isIRestModel = true;

    public error: string = null;
    public statusCode: number = null;
    public histogramLogPeriod: number = null;

    public constructor() {
        super();

        this.registerProperty('histogramLogPeriod');
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-HistogramLogConfigModel');

        this.setPropertyOriginalValue('histogramLogPeriod', this.histogramLogPeriod);
    }

    public toRestApiModel(): any {
        return {
            ...RestModelUtility.toJson(this),
        };
    }
}
